import React from 'react';
import { get } from 'lodash';

import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import { TrashIcon } from '~/components/icons';
import OptionsConfiguration from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/PhoneConfigurations/PhoneSurveyConfiguration/EditPhoneSurveyConfigDialog/components/OptionsConfiguration';
import { FORM_IDS } from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/PhoneConfigurations/PhoneSurveyConfiguration/utils/constants';
import { emptyVoiceConfig } from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/PhoneConfigurations/PhoneSurveyConfiguration/utils/helpers';
import VoiceMessageConfigurationSection from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/PhoneConfigurations/PhoneSurveyConfiguration/VoiceMessageConfigurationSection/VoiceMessageConfigurationSection';
import type {
  PhoneSurveyConfigurationModel,
  PhoneSurveyConfigurationModelPhoneSurveyQuestionConfigurationModel,
} from '~/server_shared/openapi/data-contracts';

interface QuestionItemProps {
  question: PhoneSurveyConfigurationModelPhoneSurveyQuestionConfigurationModel;
  questionIndex: number;
  configuration?: PhoneSurveyConfigurationModel;
  onRemove: (index: number) => void;
  setFieldValue: (field: string, value: unknown) => void;
  setAllowSavingWithoutNewFiles: React.Dispatch<
    React.SetStateAction<{
      welcome: boolean;
      response_line: boolean;
      illegal: boolean;
      ending: boolean;
      questions: boolean[];
    }>
  >;
}

const QuestionItem: React.FC<QuestionItemProps> = ({
  question,
  questionIndex,
  configuration,
  onRemove,
  setFieldValue,
  setAllowSavingWithoutNewFiles,
}) => {
  return (
    <div className="px-16 py-12">
      <VoiceMessageConfigurationSection
        title={`Question ${questionIndex + 1}`}
        voiceMessageConfiguration={
          get(configuration, `${FORM_IDS.QUESTIONS}.${questionIndex}.question_configuration`) || emptyVoiceConfig()
        }
        radioButtonGroupId={`${FORM_IDS.QUESTIONS}.${questionIndex}.question_configuration.configuration_type`}
        textAreaId={`${FORM_IDS.QUESTIONS}.${questionIndex}.question_configuration.message_text`}
        voiceFileInputId={`${FORM_IDS.QUESTIONS}.${questionIndex}.question_configuration.file`}
        onReplaceExistingRecording={() => {
          setFieldValue(`${FORM_IDS.QUESTIONS}.${questionIndex}.question_configuration.stored_file_id`, undefined);
          setFieldValue(
            `${FORM_IDS.QUESTIONS}.${questionIndex}.question_configuration.permanent_audio_file_url`,
            undefined
          );
          setAllowSavingWithoutNewFiles((prev) => {
            const newQuestions = [...prev.questions];
            newQuestions[questionIndex] = false;
            return { ...prev, questions: newQuestions };
          });
        }}
        storedFileIdPath={`${FORM_IDS.QUESTIONS}.${questionIndex}.question_configuration.stored_file_id`}
        actions={
          <IconButton aria-label="delete question" onClick={() => onRemove(questionIndex)} size="small">
            <TrashIcon />
          </IconButton>
        }
      >
        <OptionsConfiguration question={question} questionIndex={questionIndex} setFieldValue={setFieldValue} />
      </VoiceMessageConfigurationSection>
    </div>
  );
};

export default QuestionItem;
